import type { FC } from "react";
import type { ToasterProps } from "./toaster.types";

import {
  StyledMessageContainer,
  StyledToaster,
  StyledToasterContainer,
} from "./toaster.styles";

export const Toaster: FC<ToasterProps> = ({ message }) => {
  return (
    <StyledToaster>
      <StyledToasterContainer>
        <StyledMessageContainer>{message}</StyledMessageContainer>
      </StyledToasterContainer>
    </StyledToaster>
  );
};
